export const addInsurancePageTranslations = {
  en: {
    addInsurancePage: {
      alert:
        'Adding an insurance card saves you time upon arrival and automatically determines your coverage for this and upcoming visits.',
      confirmOutOfPocket:
        'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.',
      confirmReviewAtAppointment:
        'We will review your insurance at your appointment. Please make sure to bring your card with you.',
      provideCardAtAppointmentQuestion: 'Provide card at appointment?',
      title: 'Would you like to add an insurance card for this appointment?',
    },
  },
  es: {
    addInsurancePage: {
      alert:
        'Agregar una tarjeta de seguro le ahorra tiempo a su llegada y determina automáticamente su cobertura para esta y próximas visitas.',
      confirmOutOfPocket:
        'Sin agregar un seguro, usted puede ser totalmente responsable de pagar su factura médica de su bolsillo.',
      confirmReviewAtAppointment:
        'Revisaremos su seguro en su cita. Por favor asegúrese de traer su tarjeta con usted.',
      provideCardAtAppointmentQuestion: '¿Proporcionar tarjeta en la cita?',
      title: '¿Quiere agregar una tarjeta de seguro para esta cita?',
    },
  },
};
